<div class="confirmation-page">
  <bca-tab-stepper [highestRoute]="5" [currentRoute]="5">
    <ng-container *ngFor="let page of confirmationSteps">
      <bca-tab [done]="true" [active]="false" [route]="page.route" [title]="page.title | translate">
      </bca-tab>
    </ng-container>
  </bca-tab-stepper>

  <div class="confirmation-content">
      <div *ngIf="statusPaymentLoading$ | async; else default" class="basicLoader"></div>
      <ng-template #default>

        <!-- Failed payment state -->
        <ng-container *ngIf="hasPaymentFailed$ | async; else successLayout">
          <section>
            <h1 class="headingXL pt-4 pb-1">{{ "CONFIRMATION.TITLE_FAILED" | translate }}</h1>
            <div class="grid">
              <div class="grid__unit s-4-4 m-12-12 animated zoomIn">
                <p>{{ "CONFIRMATION.RETRY_TEXT" | translate }}</p>
                <button class="button" [cypress]="'retry_payment'" (click)="retryPayment()">
                  {{ "CONFIRMATION.BUTTON.RETRY" | translate }}
                </button>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- Success state � two-column layout -->
        <ng-template #successLayout>
          <div class="confirmation-layout">

            <!-- Left column -->
            <div class="confirmation-main">

              <!-- Title -->
              <ng-container *ngIf="isOpenPayment$ | async; else successTitle">
                <h1 class="confirmation-title">{{ "CONFIRMATION.TITLE_OPEN" | translate }}</h1>
              </ng-container>
              <ng-template #successTitle>
                <h1 class="confirmation-title">{{ "CONFIRMATION.TITLE" | translate }}</h1>
              </ng-template>

              <!-- Reference number block -->
              <ng-container *ngIf="transaction$ | async as transaction">
                <div class="confirmation-refblock" [cypress]="'transaction_result'">
                  <ng-container *ngIf="transaction.paymentStatus === PaymentStatus.Success">
                    <h2 class="confirmation-refnumber">
                      {{ "CONFIRMATION.REFNUMBER_SUBTITLE" | translate }}
                      <strong>{{ transaction.referenceNumber | formatReference }}</strong>
                    </h2>
                    <p class="confirmation-info">{{ "CONFIRMATION.INFO" | translate }}</p>
                  </ng-container>
                  <ng-container *ngIf="transaction.paymentStatus === PaymentStatus.Open">
                    <p class="confirmation-info">{{ "CONFIRMATION.PAYMENT_OPEN" | translate }}</p>
                  </ng-container>
                </div>
              </ng-container>

              <!-- Blue info box -->
              <div class="confirmation-infobox" [cypress]="'user_result'">
                <div class="infobox-item">
                  <i class="icon infobox-item__icon mail--large"></i>
                  <div>
                    <h3 class="infobox-item__title">{{ "CONFIRMATION.EMAIL_TITLE" | translate }}</h3>
                    <p class="infobox-item__text" privacySensitive>
                      {{ "CONFIRMATION.EMAIL_INFO" | translate }} {{ representativeEmail$ | async }}
                    </p>
                  </div>
                </div>
                <div class="infobox-item">
                  <i class="icon infobox-item__icon business-card--large"></i>
                  <div>
                    <h3 class="infobox-item__title">{{ "CONFIRMATION.CARD_TITLE" | translate }}</h3>
                    <p class="infobox-item__text">{{ "CONFIRMATION.CARD_TEXT" | translate }}</p>
                  </div>
                </div>
                <div class="infobox-item">
                  <i class="icon infobox-item__icon chat--large"></i>
                  <div>
                    <h3 class="infobox-item__title">{{ "CONFIRMATION.QUESTIONS_TITLE" | translate }}</h3>
                    <p class="infobox-item__text" [innerHTML]="'CONFIRMATION.QUESTIONS_TEXT' | translate"></p>
                  </div>
                </div>
              </div>

              <!-- Orders section -->
              <div class="confirmation-orders">
                <h2 class="confirmation-orders__title">{{ "CONFIRMATION.ORDERS_TITLE" | translate }}</h2>
                <div class="confirmation-orders__list">
                  <ng-container *ngFor="let product of products$ | async; let i = index">
                    <bca-product
                      [company]="company$ | async"
                      [product]="product"
                      [totalProductCount]="totalProductCount$ | async"
                      [productNumber]="i + 1"
                      [readOnly]="true"
                    ></bca-product>
                  </ng-container>
                </div>
              </div>

            </div>

            <!-- Right sidebar -->
            <div class="confirmation-sidebar">
              <div class="org-details-card" *ngIf="company$ | async as company">

                <div class="org-details-section">
                  <h4 class="org-details-title">{{ "CONFIRMATION.ORGANISATION" | translate }}</h4>
                  <p class="org-details-body">{{ company.name }}</p>
                  <p class="org-details-body">KVK-nummer {{ company.kvkNumber }}</p>
                  <p class="org-details-body">{{ company.address?.street }} {{ company.address?.houseNumber }}</p>
                  <p class="org-details-body">{{ company.address?.postcode }} {{ company.address?.city }}</p>
                </div>

                <div class="org-details-section" *ngIf="company.representative as rep">
                  <h4 class="org-details-title">{{ "CONFIRMATION.REPRESENTATIVE" | translate }}</h4>
                  <p class="org-details-body" privacySensitive>{{ rep | displayName | async }}</p>
                  <p class="org-details-body" privacySensitive>{{ rep.email }}</p>
                </div>

                <div class="org-details-section">
                  <h4 class="org-details-title">{{ "CONFIRMATION.CONTACT_PERSON" | translate }}</h4>
                  <ng-container *ngIf="company.contactPerson as cp; else repAsContact">
                    <p class="org-details-body" privacySensitive>{{ cp | displayName | async }}</p>
                    <p class="org-details-body" privacySensitive>{{ cp.email }}</p>
                  </ng-container>
                  <ng-template #repAsContact>
                    <p class="org-details-body" privacySensitive>{{ company.representative | displayName | async }}</p>
                    <p class="org-details-body" privacySensitive>{{ company.representative?.email }}</p>
                  </ng-template>
                </div>

              </div>
            </div>

          </div>
        </ng-template>

      </ng-template>

  </div><!-- /.confirmation-content -->
</div>
